import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["enabledModal", "disabledModal"]
  static values = {
    createUrl: String
  }

  async createGroupId(event) {
    const button = event.currentTarget
    button.disabled = true
    button.textContent = "Creating..."

    // Make the API call
    await post(this.createUrlValue, {
      responseKind: "turbo-stream"
    })
  }

  showToggleNotice(event) {
    const modal = event.target.checked ? this.enabledModalTarget : this.disabledModalTarget

    $(modal).modal("show")
  }
}
